import React from 'react';
// this plugin is _not_ react-native compatible and will need to get replaced with something more
// compatible when the times comes to start using react native
import InputMask from 'react-input-mask';
import type { TextFormFieldProps } from '..';
import TextFormField from './TextFormField';

type MaskedFormFieldProps = TextFormFieldProps & {
  mask: string;
  onValueChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const MaskedFormField: React.FC<MaskedFormFieldProps> = ({
  mask,
  value,
  onValueChange,
  disabled,
  ...restProps
}) => (
  // The `disabled` property needs to be specified in both locations, or else `InputMask` causes an
  // error because it thinks the caller is bypassing it since it exists on `TextFormField`. The
  // error message is "react-input-mask: the following props should be passed to the
  // react-input-mask's component and should not be altered in children's function: disabled".
  //
  // Additionally, `InputMask` causes a spurious warning from props validation.
  // "Warning: Failed prop type: The prop `value` is marked as required in `ForwardRef`, but
  // its value is `undefined`."
  //     in ForwardRef (created by InputElement)
  //     in InputElement (created by MaskedFormField)
  //     ...
  <InputMask
    value={value}
    onChange={onValueChange}
    mask={mask}
    alwaysShowMask
    disabled={!!disabled}
    {...restProps}
  >
    {inputProps => <TextFormField disabled={!!disabled} {...inputProps} />}
  </InputMask>
);
